/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class CAISODayAheadPrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "CAISODayAheadPrices";
}

const servicePlugin = makeServicePlugin({
  Model: CAISODayAheadPrices,
  service: feathersClient.service("data-services/caiso/day-ahead-locational-marginal-prices"),
  idField: "_id",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
